import React from 'react';
import { ChevronsLeft, ChevronLeft, ChevronRight, ChevronsRight } from 'lucide-react';

// Componente de paginación reutilizable.
// Props:
//   total       (int)
//   page        (int, base 1)
//   pageSize    (int)
//   onPage      (fn nuevo número de página)
//   onPageSize  (fn nuevo tamaño)
// Si total<=pageSize muestra solo el contador. Sin total no renderiza nada.
const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const Pagination = ({ total, page, pageSize, onPage, onPageSize }) => {
  if (total == null) return null;
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(Math.max(1, page), pages);
  const from = total === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const to = Math.min(safePage * pageSize, total);

  const go = (n) => {
    const next = Math.min(Math.max(1, n), pages);
    if (next !== safePage) onPage(next);
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
      padding: '10px 4px', color: '#475569', fontSize: 13,
    }}>
      <span>{from}–{to} de <strong>{total}</strong></span>

      <div style={{ display: 'flex', gap: 4 }}>
        <button type="button" className="btn btn-sm btn-outline" disabled={safePage === 1} onClick={() => go(1)} title="Primera"><ChevronsLeft size={14} /></button>
        <button type="button" className="btn btn-sm btn-outline" disabled={safePage === 1} onClick={() => go(safePage - 1)} title="Anterior"><ChevronLeft size={14} /></button>
        <span style={{ alignSelf: 'center', padding: '0 8px' }}>Página <strong>{safePage}</strong> de <strong>{pages}</strong></span>
        <button type="button" className="btn btn-sm btn-outline" disabled={safePage === pages} onClick={() => go(safePage + 1)} title="Siguiente"><ChevronRight size={14} /></button>
        <button type="button" className="btn btn-sm btn-outline" disabled={safePage === pages} onClick={() => go(pages)} title="Última"><ChevronsRight size={14} /></button>
      </div>

      <label style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 'auto' }}>
        Por página:
        <select className="form-input" style={{ width: 80, padding: '4px 8px' }} value={pageSize} onChange={(e) => onPageSize(parseInt(e.target.value, 10))}>
          {PAGE_SIZE_OPTIONS.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </label>
    </div>
  );
};

export default Pagination;
